import { IconProps } from "../../utils/global-types/global-types";

const KeyAccountManagerIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_1084_155135)">
        <path
          fill="currentColor"
          d="M1.833 8.161c0-3.908 3.234-7.033 7.167-7.033s7.167 3.125 7.167 7.033v2.83q0 .09-.01.181.01.06.01.123c0 .656-.082 1.372-.16 1.919-.124.855-.63 1.704-1.558 2.071-.998.396-2.73.843-5.45.843a.833.833 0 0 1 0-1.667c2.535 0 4.056-.416 4.836-.725.254-.1.464-.36.522-.76l.022-.156c-.469.104-1.01.205-1.549.261-.707.074-1.397-.352-1.526-1.12-.075-.447-.137-1.09-.137-2 0-.908.062-1.552.137-2 .13-.767.819-1.193 1.526-1.12.284.03.57.072.844.12-.543-2-2.413-3.5-4.674-3.5-2.26 0-4.13 1.5-4.674 3.5.275-.048.56-.09.844-.12.707-.073 1.397.353 1.526 1.12.075.448.137 1.092.137 2 0 .91-.062 1.553-.137 2-.13.768-.819 1.194-1.526 1.12a15 15 0 0 1-2.024-.373c-.8-.2-1.313-.926-1.313-1.717z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1084_155135">
          <path fill="#fff" d="M1 1h16v16H1z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default KeyAccountManagerIcon;
